<template>
    <div class="desktop-only">
        <slot />
    </div>
</template>